import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import { SocialButtonType } from '@widgets/SocialShare/types'
import SvgIcon from '@components/SvgIcon'
import config from '@config'
import { SvgIconName } from '@components/SvgIcon/types'

const {
  socialembeds: {
    share: { types: socialEmbedTypes },
  },
} = config

interface ButtonProps {
  type: SocialButtonType
  onClick: () => void
}

const Wrapper = styled.button`
  ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
        grey: { grey_90 },
      },
    },
  }) => {
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      border: 1px solid ${grey_90};
      border-radius: 50%;
      cursor: pointer;
      margin-right: 8px;
      background-color: transparent;
      padding: 0;
      line-height: 0;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      user-select: none;
      &:hover {
        border-color: ${brand_55};
        svg {
          fill: ${brand_55};
        }
      }
    `
  }}
`

const Button: FunctionComponent<ButtonProps> = ({ type, onClick }) => {
  const theme = useTheme()

  const iconName = socialEmbedTypes[type]?.iconName as SvgIconName
  const iconColor = theme.colors.grey.grey_90
  return (
    <Wrapper onClick={onClick} aria-label={type}>
      <SvgIcon iconName={iconName} size={18} color={iconColor} />
    </Wrapper>
  )
}

export default Button
